import React, { Component } from 'react'
import { hslStringToVector, hslVectorToString } from '../../../utils'

export function CurveDown ({ width }) {
  return (
    <svg width={width} height={0.5929 * width} viewBox="0 0 280 166" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g>
        <use xlinkHref="#path0asdf_fill" fill="url(#paint0asdf789_linear)"/>
      </g>
      <defs>
        <linearGradient id="paint0asdf789_linear" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(280 -165.499 219.615 429.114 -109.807 -48.557)">
          <stop offset="0" stopColor="#F2C94C"/>
          <stop offset="1" stopColor="#CCA633" stopOpacity="0"/>
        </linearGradient>
        <path id="path0asdf_fill" d="M 0 0C 0 0 3.91728 28.5861 95.2001 28.5861C 186.483 28.5861 271.49 93.9628 280 166L 0 166L 0 0Z"/>
      </defs>
    </svg>
  )
}

export function CurveUp ({ width }) {
  return (
    <svg width={width} height={0.6429 * width} viewBox="0 0 280 180" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <g id="Rectangle 19">
        <use xlinkHref="#path0a81hd01_fill" fill="url(#paint098as123_linear)"/>
      </g>
      <defs>
        <linearGradient id="paint098as123_linear" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(1.71451e-14 172.915 -280 1.0588e-14 280 7.08492)">
          <stop offset="0.0220994" stopColor="#4CF2EB"/>
          <stop offset="1" stopColor="#007AFF" stopOpacity="0"/>
        </linearGradient>
        <path id="path0a81hd01_fill" d="M 0 43C 28.718 73.8487 72.1497 31.8996 128.333 76.9004C 184.516 121.901 256.114 36.832 280 0C 280 26.7897 280 149.151 280 180L 0 180L 0 43Z"/>
      </defs>
    </svg>
  )
}

export function CurveHeader ({ width=670, mainColor='hsl(45, 86%, 62%)', className }) {
  //45, 86, 62
  //45, 60, 50
  // Reduce saturation by 26 and luminance by 12 to get the second faded out color in the gradient
  const mainColorVector = hslStringToVector(mainColor)
  const secondaryColorVector = [
    mainColorVector[0],
    mainColorVector[1] - 26,
    mainColorVector[2] - 12
  ]
  const secondaryColorVectorString = hslVectorToString(secondaryColorVector)

  return (
    <svg className={className} width="670" height="248" viewBox="0 0 670 248" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink">
      <path transform="matrix(1 0 0 -1 0 248)" fill="url(#osc7kx7sh)" d="M 0 0C 0 0 -0.000122101 43 227.8 42.7069C 455.6 42.4139 649.637 140.378 670 248L 0 248L 0 0Z"/>
      <defs>
        <linearGradient id="osc7kx7sh" x1="0" y1="0" x2="1" y2="0" gradientUnits="userSpaceOnUse" gradientTransform="matrix(552.471 -226.5 458.149 520.047 -229.074 -12.0235)">
          <stop offset="0" stopColor={mainColor}/>
          <stop offset="1" stopColor={secondaryColorVectorString} stopOpacity="0"/>
        </linearGradient>
      </defs>
    </svg>
  )
}



// WEBPACK FOOTER //
// ./src/components/visuals/curves/index.js